import { Small } from "orcs-design-system";

import { PersonNameLink } from "./PersonNameLink";

export type ExceptionReasonAttributionParts = {
  prefix: string;
  name: string;
  suffix: string;
};

/** One line under the exception-reason body. Stamp is already formatted. */
export const exceptionReasonAttributionParts = (
  personName: string | null | undefined,
  stamp: string | null | undefined
): ExceptionReasonAttributionParts | null => {
  const name = personName?.trim() ?? "";
  const at = stamp?.trim() ?? "";
  if (name && at) {
    return { prefix: "Entered by ", name, suffix: ` · ${at}` };
  }
  if (name) {
    return { prefix: "Entered by ", name, suffix: "" };
  }
  if (at) {
    return { prefix: "Entered ", name: "", suffix: at };
  }
  return null;
};

export const exceptionReasonAttribution = (
  personName: string | null | undefined,
  stamp: string | null | undefined
): string | null => {
  const parts = exceptionReasonAttributionParts(personName, stamp);
  if (!parts) {
    return null;
  }
  return `${parts.prefix}${parts.name}${parts.suffix}`;
};

export const ExceptionReasonAttribution = ({
  personName,
  personId,
  stamp,
}: {
  personName?: string | null | undefined;
  personId?: string | null | undefined;
  stamp?: string | null | undefined;
}) => {
  const parts = exceptionReasonAttributionParts(personName, stamp);
  if (!parts) {
    return null;
  }
  return (
    <Small color="greyDark">
      {parts.prefix}
      {parts.name ? (
        <PersonNameLink name={parts.name} personId={personId} />
      ) : null}
      {parts.suffix}
    </Small>
  );
};
